/*
  Japan Derm · piezas propias que el tema no hace bien (Tienda, 25-sep-2026)
  Va en layout/theme.liquid DELANTE de main.js de Shrine: los dos son defer, así que este corre antes de que el tema arranque.
  1. Shipping Protection: va marcado por defecto, pero si la clienta lo quita, no vuelve a entrar al cambiar de página.
  2. Cuenta atrás del cajón: no vuelve a empezar en cada página y en cero se para y cambia el texto.
  3. /cart: si el tema mete la protección al cargar, la página se recarga una vez para que el subtotal cuadre.
*/
(function () {
  var PROTECCION = 'shipping-protection';
  var CLAVE = 'jd_sin_proteccion';

  function leer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function escribir(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function tokenCarrito() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split('?')[0] : '';
  }
  function quitada() { var t = tokenCarrito(); return !!t && leer(CLAVE) === t; }

  // 1. La decisión de la clienta vale para su carrito: con otro carrito, la protección vuelve a ir marcada
  var SELECTOR = '[data-handle="' + PROTECCION + '"][data-toggle="true"]';
  function desmarcar(raiz) {
    if (!quitada() || !raiz) return;
    if (raiz.matches && raiz.matches(SELECTOR)) raiz.setAttribute('data-selected', 'false');
    if (raiz.querySelectorAll) raiz.querySelectorAll(SELECTOR).forEach(function (el) { el.setAttribute('data-selected', 'false'); });
  }
  desmarcar(document);
  new MutationObserver(function (cambios) {
    if (!quitada()) return;
    cambios.forEach(function (c) { c.addedNodes.forEach(function (n) { if (n.nodeType === 1) desmarcar(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Con la protección en el carrito, su interruptor va encendido. Esto corre antes de que el cajón se repinte, y Shrine
  // copia en el cajón nuevo el estado del viejo: sin esto podía salir apagado mientras se cobraba (27-sep).
  function encenderInterruptor() {
    document.querySelectorAll(SELECTOR).forEach(function (el) { el.setAttribute('data-selected', 'true'); });
  }

  var teniaProteccion = null;
  function mirarCarrito(carrito, tipo) {
    if (!carrito || !carrito.items) return;
    if (carrito.item_count === 0) escribir('jd_cuenta_' + tokenCarrito(), null); // carrito vacío: la próxima cuenta atrás empieza de cero
    var tiene = carrito.items.some(function (i) { return i.handle === PROTECCION; });
    var otros = carrito.items.some(function (i) { return i.handle !== PROTECCION; });
    if (tipo === 'cambio' && teniaProteccion === true && !tiene && otros) escribir(CLAVE, tokenCarrito());
    if (tiene) encenderInterruptor();
    teniaProteccion = tiene;
  }

  var ultimaRecarga = 0;
  function recargarSiEsElCarrito() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    var antes = 0;
    try { antes = parseInt(sessionStorage.getItem('jd_recarga_carrito'), 10) || 0; } catch (e) {}
    if (Date.now() - antes < 8000 || Date.now() - ultimaRecarga < 8000) return;
    ultimaRecarga = Date.now();
    try { sessionStorage.setItem('jd_recarga_carrito', String(ultimaRecarga)); } catch (e) {}
    setTimeout(function () { location.reload(); }, 300);
  }

  var fetchOriginal = window.fetch;
  if (fetchOriginal) {
    window.fetch = function (entrada) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var tipo = /\/cart\/add(\.js)?(\?|$)/.test(url) ? 'alta'
        : /\/cart\/(change|update)(\.js)?(\?|$)/.test(url) ? 'cambio'
        : /\/cart\.js(\?|$)/.test(url) ? 'lectura' : null;
      var promesa = fetchOriginal.apply(this, arguments);
      if (!tipo) return promesa;
      return promesa.then(function (r) {
        return r.clone().json().then(function (j) {
          if (tipo === 'alta') {
            var anadidos = j.items || [j];
            if (anadidos.some(function (i) { return i && i.handle === PROTECCION; })) {
              escribir(CLAVE, null);
              teniaProteccion = true;
              encenderInterruptor();
              recargarSiEsElCarrito();
            }
          } else {
            mirarCarrito(j, tipo);
          }
          return r;
        }).catch(function () { return r; });
      });
    };
    fetchOriginal('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (teniaProteccion === null) mirarCarrito(c, 'lectura'); })
      .catch(function () {});
  }

  // 2. Cuenta atrás del cajón, una por carrito
  if (window.customElements && !customElements.get('jd-cuenta-atras')) {
    customElements.define('jd-cuenta-atras', class extends HTMLElement {
      // Al repintar el cajón, Shrine copia el interior del aviso viejo en el nuevo: el contenedor (.cart-timer, con
      // data-jd-articulos) es siempre el nuevo, y el texto final va dentro como <span hidden>, para poder volver atrás.
      connectedCallback() {
        var caja = this.closest('.cart-timer');
        if (caja && caja.getAttribute('data-jd-articulos') === '0') return; // carrito vacío: no arranca hasta que haya algo
        var duracion = parseInt(this.dataset.duracion, 10) || 600;
        var clave = 'jd_cuenta_' + tokenCarrito();
        var fin = parseInt(leer(clave), 10);
        if (!fin) { fin = Date.now() + duracion * 1000; escribir(clave, String(fin)); }
        var activo = caja && caja.querySelector('.jd-aviso-activo');
        var final = caja && caja.querySelector('.jd-aviso-fin');
        var el = this;
        function pintar() {
          var s = Math.max(0, Math.round((fin - Date.now()) / 1000));
          if (s === 0) {
            clearInterval(el._reloj);
            if (activo && final) { activo.hidden = true; final.hidden = false; }
            else el.textContent = '00:00';
            return;
          }
          if (activo && final) { activo.hidden = false; final.hidden = true; }
          el.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
        }
        pintar();
        this._reloj = setInterval(pintar, 1000);
      }
      disconnectedCallback() { clearInterval(this._reloj); }
    });
  }
  // 4 y 5. Ofertas del carrito con interruptor (snippets/jd-ofertas-carrito.liquid), cajón y /cart:
  //   <jd-pasar-a-suscripcion> cambia la línea de compra única (por su clave) al primer plan de Skio de su variante (cart/change.js);
  //   <jd-anadir-tubo> deja el tubo extra en 1 (cart/update.js, que no suma aunque se repita) o, si ya está encendido, lo quita (cart/change.js a 0);
  //   <jd-ajustar-carrito> (abajo) corrige el carrito si se sale de las reglas.
  //   El interruptor se enciende al tocar; si la respuesta falla, el cajón se repinta con lo que hay de verdad en el carrito (/cart recarga).
  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function pedir(ruta, datos) {
    return fetch(RAIZ + ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(datos)
    })
      .then(function (r) { return r.json(); })
      .then(function (respuesta) {
        if (respuesta.status) throw new Error(respuesta.description || respuesta.message || 'error');
        return respuesta;
      });
  }
  function seccionesDelCajon(cajon) {
    return cajon && typeof cajon.getSectionsToRender === 'function'
      ? cajon.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : '';
  }
  function anunciar(cajon, texto) {
    var region = cajon && cajon.querySelector('#CartDrawer-LiveRegionText');
    if (region && texto) region.textContent = texto;
  }
  // Tras un fallo, pinta el cajón con el carrito real: si el pedido sí llegó, se ve; si no, sigue como estaba
  function resincronizar(cajon) {
    var ids = seccionesDelCajon(cajon);
    if (!cajon || !ids || typeof cajon.renderContents !== 'function') return Promise.reject(new Error('sin cajon'));
    return fetch(RAIZ + '?sections=' + ids, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (secciones) {
        if (!secciones || !secciones['cart-drawer']) throw new Error('sin secciones');
        cajon.renderContents({ sections: secciones });
      });
  }
  function enviarOferta(el, ruta, datos, origen, textoHecho) {
    if (el.classList.contains('is-cargando')) return;
    var antes = el.getAttribute('data-selected');
    var ahora = antes === 'true' ? 'false' : 'true';
    var boton = el.querySelector('.jd-oferta__boton');
    var etiqueta = el.tagName.toLowerCase();
    var teniaFoco = el.contains(document.activeElement);
    el.classList.add('is-cargando');
    el.setAttribute('data-selected', ahora);
    if (boton) boton.setAttribute('aria-pressed', ahora);
    var error = el.querySelector('.jd-pasar__error');
    if (error) error.hidden = true;
    var cajon = el.closest('cart-drawer') || null;
    var ids = seccionesDelCajon(cajon);
    if (ids) { datos.sections = ids; datos.sections_url = window.location.pathname; }
    function enfocar() {
      if (!teniaFoco || !cajon) return;
      var nuevo = cajon.querySelector(etiqueta + ' .jd-oferta__boton') || cajon.querySelector('.drawer__close');
      if (nuevo) nuevo.focus();
    }
    pedir(ruta, datos)
      .then(function (respuesta) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: origen, cartData: respuesta });
        }
        if (cajon && typeof cajon.renderContents === 'function' && respuesta.sections) {
          cajon.renderContents(respuesta);
          anunciar(cajon, textoHecho);
          enfocar();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        function avisar(destino) {
          var err = destino && destino.querySelector('.jd-pasar__error');
          if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
        }
        function volverAtras() {
          el.classList.remove('is-cargando');
          el.setAttribute('data-selected', antes);
          if (boton) boton.setAttribute('aria-pressed', antes);
          avisar(el);
        }
        if (!cajon) { volverAtras(); return; } // en /cart: cart/update.js no suma aunque se repita, así que basta con avisar
        resincronizar(cajon)
          .then(function () {
            var nuevo = cajon.querySelector(etiqueta);
            if (nuevo && nuevo.getAttribute('data-selected') === antes) avisar(nuevo);
            enfocar();
          })
          .catch(volverAtras);
      });
  }
  function definirOferta(nombre, alTocar) {
    if (!window.customElements || customElements.get(nombre)) return;
    customElements.define(nombre, class extends HTMLElement {
      connectedCallback() {
        var el = this;
        var boton = this.querySelector('.jd-pasar__boton');
        if (!boton || boton._jd) return;
        boton._jd = true;
        boton.addEventListener('click', function () { alTocar(el); });
      }
    });
  }
  definirOferta('jd-pasar-a-suscripcion', function (el) {
    enviarOferta(el, 'cart/change.js', { id: el.dataset.clave, quantity: Number(el.dataset.cantidad), selling_plan: Number(el.dataset.plan) }, 'jd-pasar-a-suscripcion', 'Switched to Automatic Refills.');
  });
  definirOferta('jd-anadir-tubo', function (el) {
    if (el.getAttribute('data-selected') === 'true' && el.dataset.clave) {
      enviarOferta(el, 'cart/change.js', { id: el.dataset.clave, quantity: 0 }, 'jd-anadir-tubo', 'Extra tube removed.');
    } else {
      var cambios = {};
      cambios[el.dataset.variante] = 1;
      enviarOferta(el, 'cart/update.js', { updates: cambios }, 'jd-anadir-tubo', 'Extra tube added.');
    }
  });
  // Reglas del carrito (snippets/jd-ofertas-carrito.liquid): el tubo solo con el 1+1 con suscripción y de uno en uno, y el
  // Shipping Protection no se queda solo. Lo que el Liquid ve fuera de regla se corrige con un cart/update.js por clave de línea.
  // La marca evita repetir la petición mientras está en curso (en /cart salen dos: el del cajón y el de la página) y se quita al
  // terminar, después de repintar: así, si la clienta vuelve a salirse de la regla en la misma página, se corrige otra vez.
  if (window.customElements && !customElements.get('jd-ajustar-carrito')) {
    customElements.define('jd-ajustar-carrito', class extends HTMLElement {
      connectedCallback() {
        var marca = this.getAttribute('data-cambios');
        var cambios;
        try { cambios = JSON.parse(marca); } catch (e) { return; }
        var hechos = window.__jdCarritoAjustado = window.__jdCarritoAjustado || {};
        if (!cambios || hechos[marca]) return;
        hechos[marca] = true;
        var cajon = this.closest('cart-drawer') || null;
        function ajustar() {
          var datos = { updates: cambios };
          var ids = seccionesDelCajon(cajon);
          if (ids) { datos.sections = ids; datos.sections_url = window.location.pathname; }
          pedir('cart/update.js', datos)
            .then(function (respuesta) {
              if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'jd-ajustar-carrito', cartData: respuesta });
              }
              if (/\/cart\/?$/.test(location.pathname)) { window.location.reload(); return; }
              if (cajon && typeof cajon.renderContents === 'function' && respuesta.sections) cajon.renderContents(respuesta);
              delete hechos[marca];
            })
            .catch(function () { delete hechos[marca]; });
        }
        // Al cargar la página este script corre antes que el de Shrine: sin <cart-drawer> definido no se puede repintar
        if (cajon && !customElements.get('cart-drawer')) customElements.whenDefined('cart-drawer').then(ajustar);
        else ajustar();
      }
    });
  }

  // 6. Barra de anuncio con calendario de festivos: aunque la página venga de la caché, el texto sale según la fecha de hoy en Nueva York.
  function hoyNuevaYork() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }
  function aplicarCalendario() {
    var hoy = hoyNuevaYork();
    document.querySelectorAll('[data-jd-calendario]').forEach(function (el) {
      var texto = null;
      String(el.dataset.jdCalendario || '').split(/\r?\n/).some(function (linea) {
        var partes = linea.split('|');
        if (partes.length < 3) return false;
        var ini = partes[0].trim();
        var fin = partes[1].trim();
        if (hoy >= ini && hoy <= fin) {
          texto = partes.slice(2).join('|').trim();
          return true;
        }
        return false;
      });
      var html = texto === null ? el.dataset.jdDefecto || '' : texto;
      if (el.innerHTML.trim() !== html.trim()) el.innerHTML = html;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aplicarCalendario);
  else aplicarCalendario();
  document.addEventListener('shopify:section:load', aplicarCalendario);
})();
